import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
} from "@mui/material";
import React from "react";
import "../../Sass/Common.scss";
import { ReactComponent as Urgent } from "../../Assets/Icons/Urgent.svg";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import { makeStyles } from "@mui/styles";

const useStyle = makeStyles((theme) => ({
  resConfirmationBox: {
    "&>div": {
      "&>div": {
        "&>h3": {
          marginTop: "30px !important",
        },
      },
      "&>div": {
        "&>h4": {
          marginTop: "25px",
        },
      },
    },
  },
  dialogActionBtn: {
    marginBottom: "20px",
  },
  iconStyle: {
    marginTop: "10px !important",
    height: "100px !important",
    width: "100px !important",
    "&>path": {
      fill: "#e6b400",
      fillOpacity: "0.6",
    },
  },
  textAlign: {
    textAlign: "center",

    paddingBottom: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: { minWidth: "690px" },
}));

const TodaysOrder = (props) => {
  const classes = useStyle();
  const {
    open,
    setOpen,
    title = "",
    body,
    actionBtnTitle = "",
    handleSubmit = () => {},
    loading = false,
    subTitle,
  } = props;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        classes={{ paper: classes.paper }}
        // maxWidth={"sm"}
        open={open}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
      >
        <Box className={classes.resConfirmationBox}>
          <DialogContent>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              marginBottom={"25px"}
            >
              <PrimaryIcon
                className={classes.iconStyle}
                height="100px"
                icon={Urgent}
                color="white"
              />
            </Box>
            <>
              <Box className={classes.textAlign}>
                <Typography fontSize="18px" regular>
                  You have already sent this order today. Are you sure you wish
                  to continue ?
                </Typography>
              </Box>
            </>
          </DialogContent>
        </Box>
        <DialogActions className={classes.dialogActionBtn}>
          <Button
            variant="contained"
            disabled={loading}
            startIcon={
              loading && <CircularProgress size="20px" color="white" />
            }
            onClick={() => handleSubmit()}
          >
            Yes
          </Button>

          <Button variant="outlined" onClick={handleClose}>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TodaysOrder;
